export { default } from './Breadcrumbs';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Breadcrumbs/index.js